import { breakpoints } from "./breakpoints";

function setHeaderHeight() {
    const header = document.querySelector('.js-header');
    const headerHeight = getComputedStyle(header).height;
    document.documentElement.style.setProperty('--header-height', headerHeight);
}

window.addEventListener('resize', setHeaderHeight);
document.addEventListener('DOMContentLoaded', setHeaderHeight);

let lastScrollTop = 0; // Keeps track of the last scroll position
const header = document.querySelector('.js-header'); // Your header element
const headerHeight = header.offsetHeight; // Get the height of the header

// Listen for the scroll event
window.addEventListener('scroll', function () {
    // If the screen width is greater than or equal to the breakpoint, skip the code
    if (window.innerWidth >= breakpoints.viewport_11) {
        return;
    }

    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    // Check if we've scrolled past the header height
    if (currentScroll > headerHeight) {
        // If we scroll past the header, add the '-sticky' class
        header.classList.add('-sticky');
    } else if (currentScroll === 0) {
        // Only remove the '-sticky' class when we scroll completely to the top
        header.classList.remove('-sticky');
    }

    // Check if we scroll past 30px after the header height
    if (currentScroll > (headerHeight + 10)) {
        // Add the '-transition' class when scrolled past 30px after the header
        header.classList.add('-transition');
    } else {
        // Remove the '-transition' class when we are within 30px of the header
        header.classList.remove('-transition');
    }

    // Check if user is scrolling up or down
    if (currentScroll < lastScrollTop) {
        // If scrolling up, add the '-active' class to show the header
        header.classList.add('-active');
    } else {
        // If scrolling down, remove the '-active' class to hide the header
        header.classList.remove('-active');
    }

    // Update lastScrollTop to the current scroll position
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Ensure it doesn't go negative
}, false);